<template lang="pug">
  div.module-settings
    div.wrap-list.py8
      a(href="/privacy_policy.pdf" target="brank").list-content.f.flex-between
        span 個人情報保護方針
        v-icon mdi-chevron-right
    div.wrap-list.py8
      a(href="/service_terms.pdf" target="brank").list-content.f.flex-between
        span 利用規約
        v-icon mdi-chevron-right
    div.wrap-list.py8
      a(href="https://deportaretechnologies.com/" target="brank").list-content.f.flex-between
        span 運営
        v-icon mdi-chevron-right
    div.wrap-list.py8
      a(@click="logout" target="brank").list-content.f.flex-between
        span.logout ログアウト
        //- v-icon mdi-chevron-right
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.module-settings {
  padding-top: $header_height;
  .wrap-list {
    border-bottom: $basic_border;
    // background: $primary_bg_color;
    .list-content {
      margin: 0 auto;
      width: $base_width_percent;
      max-width: $base_max_width_px;
      span {
        color: $primary_text_color;
      }
      .logout {
        color: $dangerous_color;
      }
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')

export default {
  computed: {
    ...mapState(['uid'])
  },
  methods: {
    ...mapActions(['signOut']),
    async logout () {
      const letLogout = confirm('ログアウトしますか?')
      if (letLogout) {
        await this.signOut()
        this.$router.push('/sign-in')
      }
    }
  }
}
</script>